import React from 'react';
import AddToCart from '../../Pages/Cart/AddToCart/AddToCart';
import NavBar from '../../Pages/Home/NavBar/NavBar';

const Cart = () => {
    return (
        <div>
            <AddToCart/>
        </div>
    );
};

export default Cart;